import React from 'react';
import { Loading } from '../CommonComponents/OPL/Loading/Loading';
import { StickyFooterLoading } from '../CommonComponents/OPL/StickyFooter/StickyFooter';
import { WorkflowStepper } from './components/WorkflowStepper/WorkflowStepper';
import { ScrollHereOnce } from '../CommonComponents/ScrollHereOnce';
import { WorkflowCard } from './components/WorkflowCard/WorkflowCard';
import { WorkflowWrapper } from './Workflow.styles';

export const WorkflowLoading = () => {
  return (
    <>
      <ScrollHereOnce options={false} />

      <WorkflowStepper isLoading />

      <WorkflowWrapper>
        <WorkflowCard>
          <Loading text="Loading..." />
        </WorkflowCard>
      </WorkflowWrapper>

      <StickyFooterLoading />
    </>
  );
};
